import { useCallback, useEffect } from 'react';

type TUseOutsideAction = {
  target: HTMLDivElement | HTMLUListElement | undefined;
  whiteList: (HTMLDivElement | HTMLButtonElement | undefined)[];
  action: () => void;
};

export const useDisplay = () => {
  const useOutsideAction = ({
    target,
    whiteList,
    action,
  }: TUseOutsideAction) => {
    const handleClickOutside = useCallback(
      (event: TouchEvent | MouseEvent) => {
        const isInside = target && !target.contains(event.target as Node);
        const isWhiteList = !!whiteList.find(item =>
          item?.contains(event.target as Node),
        );

        if (isInside && !isWhiteList) {
          action();
        }
      },
      [target, action],
    );

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
      };
    }, [target, action, handleClickOutside]);
  };
  return { useOutsideAction };
};
